import { combineDucks } from "lib/utils/duck";

import AgentsListView from "./AgentsListView/index";
import SuppliersListView from "./SuppliersListView/index";
import EditAgentCooperationView from "./EditAgentCooperationView/index";

export default combineDucks({
  AgentsListView,
  SuppliersListView,
  EditAgentCooperationView,
});



// WEBPACK FOOTER //
// ./src/modules/agents/index.js